import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import fnc from '../../mymod/commFunction';
import HongButton from '../../comm/HongButton';
import { FaCopy, FaCheck } from 'react-icons/fa';
import './CouponManage.scss';

const TAB = { COUPON: 'coupon', USAGE: 'usage' };
const STATUS_MAP = { 0: '미사용', 1: '사용', 2: '만료' };
const STATUS_CLASS = { 0: 'unused', 1: 'used', 2: 'expired' };

const CouponManage = () => {
    const location = useLocation();
    const pageTitle = location.state?.title || '쿠폰 관리';
    const [tab, setTab] = useState(TAB.COUPON);
    const [couponList, setCouponList] = useState([]);
    const [usageList, setUsageList] = useState([]);
    const [filterStatus, setFilterStatus] = useState('all');
    const [searchCode, setSearchCode] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);
    const [createAmount, setCreateAmount] = useState(10000);
    const [createCount, setCreateCount] = useState(1);
    const [isCreating, setIsCreating] = useState(false);
    const [editingMemo, setEditingMemo] = useState({ id: null, value: '' });
    const [copiedId, setCopiedId] = useState(null);
    const [copiedMulti, setCopiedMulti] = useState(false);

    useEffect(() => {
        fncSelectCoupons();
    }, []);

    useEffect(() => {
        if (tab === TAB.USAGE) fncSelectUsage();
    }, [tab]);

    function fncSelectCoupons() {
        fnc.sendAxios('/couponRoutes/selectCoupons', {}, (res) => {
            if (res && Array.isArray(res)) {
                setCouponList(getRecords(res));
            }
        });
    }

    function fncSelectUsage() {
        fnc.sendAxios('/couponRoutes/selectCouponUsage', {}, (res) => {
            if (res && Array.isArray(res)) {
                setUsageList(getRecords(res));
            }
        });
    }

    function getRecords(res) {
        return res.map((item, i) => ({ no: i + 1, ...item }));
    }

    function handleCreateCoupon() {
        const count = Math.max(1, parseInt(createCount) || 1);
        const amount = Math.max(1, parseInt(createAmount) || 10000);
        if (!window.confirm(`${count}개 쿠폰(원당 ${amount.toLocaleString()}원)을 생성하시겠습니까?`)) return;

        setIsCreating(true);
        let done = 0;
        let failed = 0;

        function createOne(i) {
            if (i >= count) {
                setIsCreating(false);
                fncSelectCoupons();
                if (failed > 0) alert(`${done}개 성공, ${failed}개 실패`);
                return;
            }
            fnc.sendAxios('/couponRoutes/insertCoupon', { amount }, (res) => {
                if (res?.success) done++; else failed++;
                createOne(i + 1);
            });
        }
        createOne(0);
    }

    function handleCopyCode(e, code, id) {
        e.stopPropagation();
        navigator.clipboard.writeText(code).then(() => {
            setCopiedId(id);
            setTimeout(() => setCopiedId(null), 1500);
        });
    }

    function handleCopySelected() {
        const codes = couponList
            .filter(r => selectedIds.includes(r.id))
            .map(r => r.coupon_code)
            .join('\n');
        navigator.clipboard.writeText(codes).then(() => {
            setCopiedMulti(true);
            setTimeout(() => setCopiedMulti(false), 1800);
        });
    }

    function handleMemoClick(e, row) {
        e.stopPropagation();
        setEditingMemo({ id: row.id, value: row.memo || '' });
    }

    function handleMemoSave(row) {
        if (editingMemo.value === (row.memo || '')) {
            setEditingMemo({ id: null, value: '' });
            return;
        }
        fnc.sendAxios('/couponRoutes/updateCouponMemo', { id: row.id, memo: editingMemo.value }, (res) => {
            if (res?.success) {
                setCouponList(prev => prev.map(r => r.id === row.id ? { ...r, memo: editingMemo.value } : r));
            }
            setEditingMemo({ id: null, value: '' });
        });
    }

    function handleMemoKeyDown(e, row) {
        if (e.key === 'Enter') handleMemoSave(row);
        if (e.key === 'Escape') setEditingMemo({ id: null, value: '' });
    }

    function handleDeleteCoupons() {
        if (selectedIds.length === 0) return;
        if (!window.confirm('선택한 쿠폰을 삭제하시겠습니까?')) return;
        fnc.sendAxios('/couponRoutes/deleteCoupons', { ids: selectedIds }, (res) => {
            if (res?.success) {
                setSelectedIds([]);
                fncSelectCoupons();
            } else {
                alert(res?.message || '삭제 실패');
            }
        });
    }

    function toggleSelect(id) {
        setSelectedIds(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    }

    function toggleAll(list) {
        const ids = list.map(r => r.id);
        const allSelected = ids.every(id => selectedIds.includes(id));
        setSelectedIds(allSelected ? [] : ids);
    }

    const filteredList = couponList.filter(r => {
        const matchStatus = filterStatus === 'all' || String(r.status) === filterStatus;
        const matchCode = r.coupon_code?.toLowerCase().includes(searchCode.toLowerCase());
        return matchStatus && matchCode;
    });

    const formatDate = (val) => {
        if (!val) return '-';
        return String(val).substring(0, 10);
    };

    const formatAmount = (val) => {
        if (val == null) return '-';
        return Number(val).toLocaleString() + '원';
    };

    return (
        <div className="CouponManage">
            <div className="title-row">
                <span className="title">{pageTitle}</span>
                <div className="tab-btns">
                    <button
                        className={`tab-btn ${tab === TAB.COUPON ? 'active' : ''}`}
                        onClick={() => setTab(TAB.COUPON)}
                    >쿠폰 목록</button>
                    <button
                        className={`tab-btn ${tab === TAB.USAGE ? 'active' : ''}`}
                        onClick={() => setTab(TAB.USAGE)}
                    >사용 내역</button>
                </div>
            </div>

            {tab === TAB.COUPON && (
                <>
                    <div className="toolbar">
                        <div className="toolbar-left">
                            <select
                                value={filterStatus}
                                onChange={e => setFilterStatus(e.target.value)}
                            >
                                <option value="all">전체</option>
                                <option value="0">미사용</option>
                                <option value="1">사용</option>
                                <option value="2">만료</option>
                            </select>
                            <input
                                type="text"
                                placeholder="쿠폰 코드 검색"
                                value={searchCode}
                                onChange={e => setSearchCode(e.target.value)}
                            />
                        </div>
                        <div className="toolbar-right">
                            <div className="create-inputs">
                                <label>금액</label>
                                <input
                                    type="number"
                                    min="1"
                                    step="1000"
                                    value={createAmount}
                                    onChange={e => setCreateAmount(e.target.value)}
                                />
                                <label>개수</label>
                                <input
                                    type="number"
                                    min="1"
                                    max="100"
                                    value={createCount}
                                    onChange={e => setCreateCount(e.target.value)}
                                />
                            </div>
                            <div className="action-btn-row">
                                <HongButton
                                    color='blue'
                                    onClick={handleCreateCoupon}
                                    disabled={isCreating}
                                >{isCreating ? '생성중...' : '쿠폰 생성'}</HongButton>
                                {selectedIds.length > 1 && (
                                    <HongButton
                                        color={copiedMulti ? 'green' : 'sky'}
                                        onClick={handleCopySelected}
                                    >
                                        {copiedMulti ? `선택 ${selectedIds.length}개 복사됨!` : `선택 ${selectedIds.length}개 코드 복사`}
                                    </HongButton>
                                )}
                                <HongButton
                                    color='gray'
                                    onClick={fncSelectCoupons}
                                >{'새로고침'}</HongButton>
                                <HongButton
                                    color='red'
                                    onClick={handleDeleteCoupons}
                                    disabled={selectedIds.length === 0}
                                >삭제</HongButton>
                            </div>
                        </div>
                    </div>

                    <div className="table-wrap">
                        {filteredList.length === 0 ? (
                            <div className="no-data">데이터가 없습니다.</div>
                        ) : (
                            <table className="coupon-table">
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                onChange={() => toggleAll(filteredList)}
                                                checked={filteredList.length > 0 && filteredList.every(r => selectedIds.includes(r.id))}
                                            />
                                        </th>
                                        <th>No</th>
                                        <th>쿠폰 코드</th>
                                        <th></th>
                                        <th>금액</th>
                                        <th>상태</th>
                                        <th>사용자명</th>
                                        <th>생성자</th>
                                        <th>만료일</th>
                                        <th>생성일</th>
                                        <th>메모 (배포내역)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredList.map((row) => (
                                        <tr
                                            key={row.id}
                                            className={selectedIds.includes(row.id) ? 'selected' : ''}
                                            onClick={() => toggleSelect(row.id)}
                                        >
                                            <td onClick={e => e.stopPropagation()}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds.includes(row.id)}
                                                    onChange={() => toggleSelect(row.id)}
                                                />
                                            </td>
                                            <td>{row.no}</td>
                                            <td className="code-mono">{row.coupon_code}</td>
                                            <td className="copy-td" onClick={e => e.stopPropagation()}>
                                                <button
                                                    className={`copy-btn ${copiedId === row.id ? 'copied' : ''}`}
                                                    onClick={e => handleCopyCode(e, row.coupon_code, row.id)}
                                                    title="코드 복사"
                                                >
                                                    {copiedId === row.id ? <FaCheck /> : <FaCopy />}
                                                </button>
                                            </td>
                                            <td className="amount-cell">{formatAmount(row.amount)}</td>
                                            <td>
                                                <span className={`status-badge ${STATUS_CLASS[row.status]}`}>
                                                    {STATUS_MAP[row.status] ?? '-'}
                                                </span>
                                            </td>
                                            <td>{row.user_name || '-'}</td>
                                            <td>{row.created_by || '-'}</td>
                                            <td>{formatDate(row.expires_at)}</td>
                                            <td>{formatDate(row.created_at)}</td>
                                            <td
                                                className="memo-cell"
                                                onClick={e => handleMemoClick(e, row)}
                                            >
                                                {editingMemo.id === row.id ? (
                                                    <input
                                                        className="memo-input"
                                                        autoFocus
                                                        value={editingMemo.value}
                                                        onChange={e => setEditingMemo(prev => ({ ...prev, value: e.target.value }))}
                                                        onBlur={() => handleMemoSave(row)}
                                                        onKeyDown={e => handleMemoKeyDown(e, row)}
                                                        onClick={e => e.stopPropagation()}
                                                    />
                                                ) : (
                                                    <span className={`memo-text ${row.memo ? 'has-memo' : 'empty'}`}>
                                                        {row.memo || '클릭하여 입력'}
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                    <div className="coupon-bottom-gap" aria-hidden="true" />
                </>
            )}

            {tab === TAB.USAGE && (
                <>
                    <div className="toolbar">
                        <div className="toolbar-left" />
                        <div className="toolbar-right">
                            <HongButton color='gray' onClick={fncSelectUsage}>{'새로고침'}</HongButton>
                        </div>
                    </div>
                    <div className="table-wrap">
                        {usageList.length === 0 ? (
                            <div className="no-data">{'데이터가 없습니다.'}</div>
                        ) : (
                            <table className="usage-table">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>{'쿠폰 코드'}</th>
                                        <th>{'사용자 ID'}</th>
                                        <th>{'사용자명'}</th>
                                        <th>{'금액'}</th>
                                        <th>{'사용일시'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usageList.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.no}</td>
                                            <td className="code-mono">{row.coupon_code}</td>
                                            <td>{row.user_id}</td>
                                            <td>{row.user_name || '-'}</td>
                                            <td className="amount-cell">{formatAmount(row.amount)}</td>
                                            <td>{formatDate(row.used_at)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                    <div className="coupon-bottom-gap" aria-hidden="true" />
                </>
            )}
        </div>
    );
};

export default CouponManage;
